import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { loginUser, clearError } from '../../redux/slices/authSlice';
import LoadingProgress from '../LoadingProgress/LoadingProgress';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const { loading, error, loginProgress } = useSelector((state) => state.auth);
  const { currentLanguage } = useSelector((state) => state.language);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password })).then((action) => {
      if (loginUser.fulfilled.match(action)) {
        setTimeout(() => {
          onClose();
        }, 1500);
      }
    });
  };
  
  const handleClose = () => {
    dispatch(clearError());
    onClose();
  };
  
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="login-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div 
            className="login-modal"
            initial={{ scale: 0.8, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 50 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClose}>
              ✕
            </button>
            
            <div className="modal-header">
              <h2>{currentLanguage === 'en' ? 'Welcome Back' : 'مرحبًا بعودتك'}</h2>
              <p>{currentLanguage === 'en' ? 'Sign in to your Sanad Insurance account' : 'سجل الدخول إلى حسابك في سند للتأمين'}</p>
            </div>
            
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">
                  {currentLanguage === 'en' ? 'Email Address' : 'البريد الإلكتروني'}
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={currentLanguage === 'en' ? 'user@sanad.com' : 'user@sanad.com'}
                  required
                  disabled={loading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">
                  {currentLanguage === 'en' ? 'Password' : 'كلمة المرور'}
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={currentLanguage === 'en' ? '••••••••' : '••••••••'}
                  required
                  disabled={loading}
                />
              </div>
              
              <div className="form-actions">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={loading}
                >
                  {loading ? (
                    <LoadingProgress progress={loginProgress} />
                  ) : (
                    currentLanguage === 'en' ? 'Sign In' : 'تسجيل الدخول'
                  )}
                </button>
                
                <div className="demo-credentials">
                  <p>{currentLanguage === 'en' ? 'Demo Credentials:' : 'بيانات تجريبية:'}</p>
                  <p>Email: user@sanad.com</p>
                  <p>Password: password123</p>
                </div>
              </div>
              
              {error && (
                <motion.div 
                  className="error-message"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  {error}
                </motion.div>
              )}
              
              {loginProgress === 100 && (
                <motion.div 
                  className="success-message"
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  {currentLanguage === 'en' ? 'Login successful! Redirecting...' : 'تم تسجيل الدخول بنجاح! جاري التوجيه...'}
                </motion.div>
              )}
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoginModal;